import React, { useState, useEffect, useRef, FC } from "react";
import FormItem from "containers/PageAddListing1/FormItem";
import Select from "shared/Select/Select";

interface Props {
  onClick?: () => void;
  onChange?: (value: string) => void;
  className?: string;
  defaultValue?: string;
  headingText?: string;
}

const LocationInput: FC<Props> = ({
  onChange = () => {},
  className = "",
  defaultValue = "United States",
  headingText = "",
}) => {
  const [value, setValue] = useState("");
  const containerRef = useRef(null);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleOnChange = (e: any) => {
    const selectedValue = e?.target?.value;
    setValue(selectedValue);
    onChange(selectedValue);
  };

  return (
    <div className={`${className}`} ref={containerRef}>
      <span className="block font-semibold text-xl sm:text-2xl">
        {headingText}
      </span>
      <FormItem>
        <Select onChange={handleOnChange} value={value}>
          <option value="party">Διοργάνωσε Πάρτι</option>
          <option value="exodos">
            Έξοδος για την οικογένεια και το παιδί
          </option>
        </Select>
      </FormItem>
    </div>
  );
};

export default LocationInput;
